import posthog from 'posthog-js';
import localStore from 'store2';

import { POSTHOG_PUBLIC_HOST, POSTHOG_PUBLIC_KEY } from 'utils/setting';
import { IProfile } from 'models/profileModel';

export function SetUpPosthog() {
  posthog.init(POSTHOG_PUBLIC_KEY as string, {
    api_host: POSTHOG_PUBLIC_HOST,
    autocapture: !isTestUser(),
    disable_session_recording: isTestUser(),
    capture_pageview: !isTestUser(),
  });

  if (isTestUser()) {
    posthog.opt_out_capturing();
  }
}

function isTestUser() {
  const currentUser = localStore.get(process.env.REACT_APP_LOCAL_STORAGE_CURRENT_USER) as IProfile;
  if (currentUser?.isTestingAccount) {
    return true;
  }

  return false;
}
